import swipers from "../modules/swipers.js";
import {startTimerFromEndDate, startTimer} from "./timer.js";
document.addEventListener('DOMContentLoaded', ()=>{
    console.log(ajaxObject.booking_url)



    const bookingId = document.querySelector('main#main').dataset.bookingId;

    const bookingPage = document.querySelector('body.page-template-page-booking');

    if (!bookingPage)
        return;


    const bookingExtrasWrapper = document.getElementById('bookingExtrasWrapper')

    // const bookingExtrasItemsWrapper = document.getElementById('bookingExtrasItemsWrapper');
    const bookingExtrasItemsWrapper = document.getElementById('bookingExtrasContentWrapper');
    let bookingExtrasContent = document.getElementById('bookingExtrasContent');

    // if (!bookingExtrasWrapper)
    //     return;


    const extras = document.querySelectorAll('._js-booking-extra-card');

    let bookingUpgrades = null; //TODO// Sitas turi but kazkaip updatintas jeigu yra reload...

    const extrasCtaWrapper = document.querySelectorAll('.extras-cta-wrapper');

    extrasCtaWrapper.forEach(wrapper =>{

        const extraId = wrapper.dataset.id;
        const parent = wrapper.closest('._js-booking-extra-card');

        const addButton = wrapper.querySelector('[data-action=add]');
        const removeButton = wrapper.querySelector('[data-action=remove]');

        if (addButton){
            addButton.addEventListener('click', ()=>{
                // addExtra(extraId);
                addButton.classList.add('hidden');
                removeButton.classList.remove('hidden');

                if (!parent.classList.contains('active')){
                    parent.classList.add('active')
                }

                increaseExtra(extraId);
            })
        }

        if (removeButton){
            removeButton.addEventListener('click', ()=>{
                // addExtra(extraId);
                removeButton.classList.add('hidden');
                addButton.classList.remove('hidden');

                decreaseExtra(extraId);

            })
        }

        if (!addButton){
            const increaseButton = wrapper.querySelector('[data-action=increase]');
            const decreaseButton = wrapper.querySelector('[data-action=decrease]');
            const quantityDisplay = wrapper.querySelector('.quantity-display');

            decreaseButton.addEventListener('click', ()=>{
                decreaseExtra(extraId, quantityDisplay)
            });

            increaseButton.addEventListener('click', ()=>{
                increaseExtra(extraId, quantityDisplay);
                if (!parent.classList.contains('active')){
                    parent.classList.add('active')
                }
            });


        }
    })


    // This actually removes all extras (upgrades) because this is how Flanco API works.
    function decreaseExtra(id, displayElement){

        //hide with hidden class
        bookingExtrasContent = document.getElementById('bookingExtrasContent');
        bookingExtrasContent.classList.add('hidden');


        console.log(id);

        console.log(bookingUpgrades)

        const data = new FormData();

        data.append('action', 'remove_upgrade');
        data.append('booking_id', bookingId);
        data.append('nonce', ajaxObject.nonce)

        bookingUpgrades.forEach(upgrade=>{
            if (upgrade['product'] === id){
                console.log(upgrade['_id'][0])
                data.append('extra_upgrade_id', upgrade['_id'][0]);
            }
        });

        fetch(ajaxObject.ajax_url, {
            method: 'POST',
            body: data
        })
            .then(response=>{
                if (!response.ok) {
                    throw new Error(`[${response.status}] ${response.statusText}`);
                }
                return response.json();
            })
            .then(response => {
                console.log(response);

                resetExtras()

            })
            .catch(error => {
                console.error(error)
                //If error remove hidden class to display extras...
                //But depends what error tbh
                //TODO: fix this i think
                bookingExtrasContent.classList.remove('hidden');
            })
    }


    function resetExtras(){
        extras.forEach(card=>{
            card.classList.remove('active');
            const quantity = card.querySelector('.quantity-display');

            if (quantity){
                quantity.innerText = 0;
            }

            const addButton = card.querySelector('[data-action=add]');
            const removeButton = card.querySelector('[data-action=remove]');

            if (addButton && removeButton) {
                addButton.classList.remove('hidden');
                removeButton.classList.add('hidden');
            }
        })

        // extras sidebar

    }




    function increaseExtra(id, displayElement){

        if (displayElement){
            let counter = Number(displayElement.innerText);
            counter++;

            displayElement.innerText = counter;
        }

        console.log(id)

        const data = new FormData();

        data.append('action', 'add_upgrade');
        data.append('extra_upgrade_id', id);
        data.append('booking_id', bookingId);
        data.append('nonce', ajaxObject.nonce)

        //TODO
        // ajax call man rodo ar tiesiog API call per js?
        // pass / get data
        // update quanitity
        // updatate UI
        // update booking
        // atnaujinti booking info (extra section)




        fetch(ajaxObject.ajax_url, {
            method: 'POST',
            body: data
        })
            .then(response=>{
                if (!response.ok) {
                    throw new Error(`[${response.status}] ${response.statusText}`);
                }
                return response.json();
            })
            .then(response => {
                console.log(response);
                // console.log(response.data.html);
                console.log(response.data?.data?.productsGrouped)
                const allGroupedProducts = response.data?.data?.productsGrouped;

                bookingUpgrades = allGroupedProducts.filter(upgrade => upgrade.upgrade);
                console.log(bookingUpgrades)
                bookingExtrasItemsWrapper.innerHTML = response.data.html;

                updateCards(extras)

            })
            .catch(error => {
                console.error(error)
            })
    }



    function loadBookingUpgrades(){

        const data = new FormData();

        data.append('action', 'load_booking_upgrades');
        data.append('booking_id', bookingId);
        data.append('nonce', ajaxObject.nonce);


        fetch(ajaxObject.ajax_url, {
            method: 'POST',
            body: data
        }).then(response=>{
            if (!response.ok) {
                throw new Error(`[${response.status}] ${response.statusText}`);
            }
            return response.json();
        })
            .then(response => {
                // console.log(response?.productsGrouped);
                const allGroupedProducts = response?.productsGrouped

                if (allGroupedProducts){
                    bookingUpgrades = allGroupedProducts.filter(upgrade => upgrade.upgrade);
                }

                if (response?.expiresAt) {
                    const expirationDate = new Date(response?.expiresAt);

                    if (document.querySelector('#time')) {

                        // Use the timer functions from timer-utils.js
                        var display = document.querySelector('#time');
                        startTimerFromEndDate(expirationDate, display, function () {
                            timeExpired()
                        });
                        //
                        // startTimer(5, display, function () {
                        //     console.log('Time expired!');
                        //     timeExpired()
                        // });
                    }
                }


            })
            .catch(error => {
                console.error(error)
            })
    }

    loadBookingUpgrades()


    function timeExpired(){

        console.log('does this still fire?')

        const timerExpiredModal = document.getElementById('timerExpiredModal');
        timerExpiredModal.classList.remove('hidden');
        timerExpiredModal.classList.add('flex');

        let count = 9;
        const display = document.getElementById('backToMainPageTime');
        const timer = setInterval(() => {
            display.textContent = count;
            if (count === 0) {
                clearInterval(timer);
                window.location.href = ajaxObject.rooms_url;
            }
            count--;
        }, 1000);

    }

})


function updateCards(extraCards){
    extraCards.forEach(card=>{
        const extraCardType = card.dataset.type;

        const decreaseButton = card.querySelector('[data-action=decrease]');

        if (extraCardType === 'multiple'){
            const quantityElement = card.querySelector('.quantity-display');
            const quantity = Number(quantityElement.innerText);

            console.log(quantity)
            if (quantity > 0) {
                card.classList.add('active');
                decreaseButton.removeAttribute('disabled')
            }else{
                card.classList.remove('active');
            }
        }
    })

}

//single room inner button
const bookNowButton = document.querySelector('._js-book-now');
/*
 * GTM tracking add_to_cart event.
 */

let gtmAddToCartObject;

if (bookNowButton) {
    const url =  window.location.search;
    const urlParams = new URLSearchParams(url);

    const season = urlParams.get('season');
    const room_id = urlParams.get('room_id');

    bookNowButton.addEventListener('click', ()=>{
        console.log('season ', season)
        console.log('room_id ', room_id)

        const data = new FormData();

        createGTMObject()

        data.append('action', 'create_booking');
        data.append('season', season);
        data.append('room_id', room_id);
        data.append('nonce', ajaxObject.nonce)

        bookRoom(data)
    })
}

function createGTMObject(){
    const roomPage = document.querySelector('.room-inner-page');

    const price = roomPage.querySelector('.price').innerText;

    const roomTitle = roomPage.dataset.roomTitle;
    const roomId = roomPage.dataset.roomId;

    const obj = {
        "event": "add_to_cart",
        "ecommerce": {
            "currency": "PLN",
            "value": price,
            "items": [
                {
                    "item_id": roomId,
                    "item_name": roomTitle,
                    "price": price,
                    "quantity": 1,
                    "item_category": "long-term",
                }
            ]
        }
    }

    gtmAddToCartObject = obj
}





function bookRoom(data){
    fetch(ajaxObject.ajax_url, {
        method: 'POST',
        body: data
    })
        .then(response=>{
            if (!response.ok) {
                throw new Error(`[${response.status}] ${response.statusText}`);
            }
            return response.json();
        })
        .then(response => {
            // console.log(response);
            // console.log(response.data._id);
            // console.log(gtmAddToCartObject);

            //TODO: add push layer.
            // Ensure dataLayer exists
            window.dataLayer = window.dataLayer || [];

            dataLayer.push({ ecommerce: null });
            dataLayer.push(gtmAddToCartObject);


            const booking_url = ajaxObject.booking_url;
            setTimeout(() => {
                window.location.href = `${booking_url}${response.data._id}`;
            }, 100)
        })
        .catch(error => {
            console.error(error)
        })
}

// 68230deaa57fdd01e7b2e8b9